import { create_private_room } from './chat_utils';


export default class ChatAddDirectRoom {
    constructor(opts) {
        this.user = opts.user;
        this.users_list = [...frappe.user.get_emails(), 'Administrator'];
        this.user_email = opts.user_email;
        this.users_list = this.users_list.filter(function (user) {
            return user != opts.user_email;
        });
        this.setup();
    }

    get_users(vals) {
        return new Promise((resolve, reject) => {
            frappe.call({
                method: "chat.frappe_chat.doctype.chat_groups.chat_groups.get_users",
                args: vals,
                freeze: true,
                freeze_message: "Saving...",
                callback: async function (data) {
                    let response = data.message

                    resolve(response)
                }
            });
        })
    }

    async setup() {
        let self = this
        this.add_room_dialog = new frappe.ui.Dialog({
            title: __('New Direct Chat'),
            fields: [
                {
                    label: __('User Type'),
                    fieldname: 'user_type',
                    fieldtype: 'Select',
                    options: ["Parent", "Staff"],
                    onchange: () => {
                        self.add_room_dialog.fields_dict.staff.set_value('')
                        self.add_room_dialog.fields_dict.student.set_value('')
                        let get_value = self.add_room_dialog.fields_dict['user_type'].get_value()
                        if (get_value == "Parent") {

                            // self.add_room_dialog.fields[1].reqd = 0
                            this.add_room_dialog.set_df_property('staff', 'reqd', 0);
                            this.add_room_dialog.set_df_property('student', 'reqd', 1);
                            self.add_room_dialog.fields_dict.student.toggle('show')
                            self.add_room_dialog.fields_dict.staff.toggle()

                        } else {
                            // self.add_room_dialog.fields[2].reqd = 0
                            self.add_room_dialog.fields_dict.staff.toggle('show')

                            this.add_room_dialog.set_df_property('staff', 'reqd', 1);
                            this.add_room_dialog.set_df_property('student', 'reqd', 0);

                            self.add_room_dialog.fields_dict.student.toggle()

                        }
                    }
                },
                {
                    label: __('Staff'),
                    fieldname: 'staff',
                    fieldtype: 'Link',
                    options: "Staff",
                    get_query: function () {
                        return {
                            filters: {
                                "user": ["not in", [frappe.session.user]],
                            }
                        };
                    },
                },
                {
                    label: __('Student'),
                    fieldname: 'student',
                    fieldtype: 'Link',
                    options: "Student",
                    get_query: function () {
                        return {
                            filters: {
                                "contact_person_email": ["not in", [frappe.session.user]],
                            }
                        };
                    },
                },
            ],
            action: {
                primary: {
                    label: __('Create'),
                    onsubmit: async (values) => {
                        let room_name = values.room_name;
                        let get_users = await this.get_users(values)
                        if (get_users) {
                            room_name = 'Direct Room';
                            let users = [get_users];
                            this.handle_room_creation(room_name, users, "Direct");
                            this.add_room_dialog.hide();
                        } else {

                            this.add_room_dialog.hide();
                            if (values.user_type == "Parent") {
                                frappe.throw(__('Student has no contact person'))
                            }
                            else {
                                frappe.throw(__('Staff has no user'))
                            }

                        }

                    },
                },
            },
        });

        if (frappe.user_roles.includes('Parent') && user != "Administrator") {

            // this.add_room_dialog.fields[0].reqd = 0
            // this.add_room_dialog.fields[1].reqd = 0
            this.add_room_dialog.fields_dict.staff.toggle('show')
            this.add_room_dialog.set_df_property('staff', 'reqd', 1);

            this.add_room_dialog.fields_dict.user_type.toggle()
            this.add_room_dialog.fields_dict.student.toggle()
            // this.add_room_dialog.fields[1].reqd = 1
        }
        else {
            this.add_room_dialog.set_df_property('user_type', 'reqd', 1);
            this.add_room_dialog.fields_dict.staff.toggle()
            this.add_room_dialog.fields_dict.student.toggle()
        }


    }

    show() {
        this.add_room_dialog.show();
    }

    async handle_room_creation(room_name, users, type) {
        try {
            await create_private_room(room_name, users, type);
            this.add_room_dialog.clear();
        } catch (error) {
            //pass
        }
    }
}